/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import RouteNames from '../../RouteNames';

import MfaVerifyMobileNumber from './MfaVerifyMobileNumber';
import { EnableMfaFlowActions } from '../../redux/userFlowActions';
import { getEnableMfaFlowData, getLoggedInUser } from '../../redux/reduxSelectors';
import { authToken, StorageKeys } from '../../../../utilities/LocalStorage';
import NavigationActions, { navigateBack } from '../../redux/NavigationActions';

function mapStateToProps(state, routerProps) {
  const history = routerProps.history;
  const enableMfaData = getEnableMfaFlowData(state);
  const user = getLoggedInUser(state);

  return {
    mfaEnableIsInitated: enableMfaData.isInit,
    token: authToken.get(StorageKeys.AUTH_TOKEN),
    errorMessage: '',
    isMfaEnabled: user.isMfaEnabled(),
    cancelMfaRoute: RouteNames.mfaSetMobileNumber(),
    mfaCode: enableMfaData.mfaCode,
    mobileNumber: enableMfaData.mobileNumber,
    goBack: () => {
      EnableMfaFlowActions.undoMobileNumber();
      NavigationActions.goBackTo(history, RouteNames.mfaSetMobileNumber());
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    submitMfaCode: (mfaCode, callback) => {
      dispatch(EnableMfaFlowActions.enableMfa(mfaCode, callback));
    },
    onChangeMfaCode: (mfaCode) => {
      dispatch(EnableMfaFlowActions.mfaCode(mfaCode));
    },
    finishedVerifying: () => {
      dispatch(EnableMfaFlowActions.reset());
      navigateBack(RouteNames.accountSettings());
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MfaVerifyMobileNumber);
